'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var CID = require('cids');

var errCode = require('err-code');

var _require = require('streaming-iterables'),
    parallelMap = _require.parallelMap,
    filter = _require.filter;

var pipe = require('it-pipe');

var _require2 = require('../pin/pin-manager'),
    PinTypes = _require2.PinTypes;

var _require3 = require('./utils'),
    cleanCid = _require3.cleanCid;

var _require4 = require('../../utils'),
    withTimeoutOption = _require4.withTimeoutOption;

var BLOCK_RM_CONCURRENCY = 8;

module.exports = function (_ref) {
  var blockService = _ref.blockService,
      gcLock = _ref.gcLock,
      pinManager = _ref.pinManager;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _rm = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cids, options) {
      var release;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = options || {};

              if (!Array.isArray(cids)) {
                cids = [cids];
              } // We need to take a write lock here to ensure that adding and removing
              // blocks are exclusive operations


              _context2.next = 4;
              return _awaitAsyncGenerator(gcLock.writeLock());

            case 4:
              release = _context2.sent;
              _context2.prev = 5;
              return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(pipe(cids, parallelMap(BLOCK_RM_CONCURRENCY, /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
                  var result, pinResult, has;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          cid = cleanCid(cid);
                          result = {
                            cid: cid
                          };
                          _context.prev = 2;
                          _context.next = 5;
                          return pinManager.isPinnedWithType(cid, PinTypes.all);

                        case 5:
                          pinResult = _context.sent;

                          if (!pinResult.pinned) {
                            _context.next = 10;
                            break;
                          }

                          if (!CID.isCID(pinResult.reason)) {
                            _context.next = 9;
                            break;
                          }

                          throw errCode(new Error("pinned via ".concat(pinResult.reason)));

                        case 9:
                          throw errCode(new Error("pinned: ".concat(pinResult.reason)));

                        case 10:
                          _context.next = 12;
                          return blockService._repo.blocks.has(cid);

                        case 12:
                          has = _context.sent;

                          if (has) {
                            _context.next = 15;
                            break;
                          }

                          throw errCode(new Error('block not found'), 'ERR_BLOCK_NOT_FOUND');

                        case 15:
                          _context.next = 17;
                          return blockService.delete(cid);

                        case 17:
                          _context.next = 22;
                          break;

                        case 19:
                          _context.prev = 19;
                          _context.t0 = _context["catch"](2);

                          if (!options.force) {
                            _context.t0.message = "cannot remove ".concat(cid, ": ").concat(_context.t0.message);
                            result.error = _context.t0;
                          }

                        case 22:
                          return _context.abrupt("return", result);

                        case 23:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[2, 19]]);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }()), filter(function () {
                return !options.quiet;
              }))), _awaitAsyncGenerator), "t0", 7);

            case 7:
              _context2.prev = 7;
              release();
              return _context2.finish(7);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[5,, 7, 10]]);
    }));

    function rm(_x, _x2) {
      return _rm.apply(this, arguments);
    }

    return rm;
  }());
};